import { z } from 'zod';
/**
 * Настройки SMTP. Singleton, редактируется только ADMIN через UI.
 *
 * Пароль хранится в БД зашифрованным (AES-256-GCM ключом от JWT_SECRET).
 * В DTO он НИКОГДА не возвращается — только маркер `passwordSet: boolean`.
 * При PUT — если поле `password` пришло null/undefined, существующий пароль
 * не меняется. Если пришла строка — заменяется на её зашифрованную версию.
 */
const trimmedOrNull = z.preprocess((v) => {
    if (v === null || v === undefined)
        return null;
    if (typeof v !== 'string')
        return v;
    const t = v.trim();
    return t === '' ? null : t;
}, z.string().nullable());
export const mailerSettingsInputSchema = z.object({
    enabled: z.boolean(),
    host: trimmedOrNull,
    port: z.number().int().min(1).max(65535).nullable(),
    secure: z.boolean(),
    /** Принимать самоподписанные TLS-сертификаты (для внутренних SMTP). */
    allowSelfSigned: z.boolean(),
    username: trimmedOrNull,
    /** null — не менять; '' — стереть; строка — поставить новый. */
    password: z.string().nullable().optional(),
    mailFrom: z
        .preprocess((v) => {
        if (v === null || v === undefined)
            return null;
        if (typeof v !== 'string')
            return v;
        const t = v.trim();
        return t === '' ? null : t;
    }, z.string().email('mailFrom должен быть валидным email').nullable()),
});
/** Ответ GET: пароль маскируется, отдаётся только флаг `passwordSet`. */
export const mailerSettingsDtoSchema = z.object({
    enabled: z.boolean(),
    host: z.string().nullable(),
    port: z.number().nullable(),
    secure: z.boolean(),
    allowSelfSigned: z.boolean(),
    username: z.string().nullable(),
    passwordSet: z.boolean(),
    mailFrom: z.string().nullable(),
    lastTestedAt: z.string().datetime().nullable(),
    lastTestStatus: z.enum(['ok', 'failed']).nullable(),
    lastTestError: z.string().nullable(),
    updatedAt: z.string().datetime().nullable(),
    updatedByUserEmail: z.string().nullable(),
});
export const mailerTestRequestSchema = z.object({
    to: z.string().email('to должен быть валидным email'),
});
export const mailerTestResponseSchema = z.object({
    ok: z.boolean(),
    error: z.string().nullable(),
});
//# sourceMappingURL=mailer-settings.js.map